// Mirrors Finkit.Host.TerminalManagement contracts
// (TerminalRequestDto / TerminalRequestDetailsDto / filter + ref + status inputs).

// Finkit.Enums.TerminalManagement.RequestStatus (numeric values are the wire
// contract — the row-action visibility and UpdateStatus payload depend on them).
export enum RequestStatus {
  Pending = 1,
  Processing = 2,
  Approved = 3,
  Rejected = 4,
}

export interface TerminalRequestDto {
  id: string;
  tenantId?: string | null;
  tenantName: string;
  // Server-rendered display name ("Add"/"Update").
  requestType: string;
  userName: string;
  requestDate: string;
  // Server-rendered display name ("Pending"/"Processing"/…).
  status: string;
  statusId: number;
  terminalName: string;
  connectionType: string;
}

export interface TerminalRequestDetailsDto {
  id: string;
  tenantName: string;
  userName: string;
  requestType: string;
  status: string;
  statusId: number;
  terminalName: string;
  connectionType: string;
  requestDate: string;
  approvalDate?: string | null;
  server?: string | null;
  accountLogin?: string | null;
  password?: string | null;
  enabled?: boolean | null;
}

// TerminalRequestFilterInput : PaginatedInputDto.
export interface TerminalRequestFilterInput {
  skipCount: number;
  maxResultCount: number;
  sorting?: string;
  draw?: number;
  search?: string;
  status?: string;
}

export interface TerminalRequestRefInput {
  tenantId: string;
  requestId: string;
}

export interface UpdateTerminalRequestStatusInput extends TerminalRequestRefInput {
  newStatusId: number;
}
